<template>
  <v-container class="layout-container">
    <Products
      :country-code="countryCode"
      allow-country-selection
      @productSelected="handleLightProductSelected"
    />
  </v-container>
</template>

<script>
import Products from '@/components/Products'

export default {
  components: {
    Products,
  },
  computed: {
    countryCode() {
      const locale = this.getNavigatorLanguage
      return locale?.split('-')[1] || 'DE'
    },
    getNavigatorLanguage() {
      if (navigator.languages && navigator.languages.length) {
        return navigator.languages[0]
      } else {
        return navigator.userLanguage || navigator.language || navigator.browserLanguage
      }
    },
  },
  methods: {
    handleLightProductSelected({ isBookable }) {
      if (isBookable) {
        window.open(window.location.origin + '/auth/signup')
      }
    },
  },
}
</script>
